export const VERSION = "1.12.0";